const bmiDisplayOptions = [
  { value: '0', label: 'Select', exp: 'Select' },
  { value: '1', label: 'Obese BMI Score > 30' },
  { value: '2', label: 'Overweight BMI Score 25-30'},
  { value: '3', label: 'Normal BMI Score 18.5-25'},
  { value: '4', label: 'Unknown'},
]

export default bmiDisplayOptions
